import { LogLevel } from '../app/app.service';

export const environment = {
  production: true,
  test: false,
  firebase: {
    apiKey: 'AIzaSyC9s1P4sB7GVElZt4-i4h3EMqqcC4kbpWI',
    authDomain: 'dashboard.monsuividiet.com', //'monsuividiet-prod-v2.firebaseapp.com',
    projectId: 'monsuividiet-prod-v2',
    storageBucket: 'monsuividiet-prod-v2.appspot.com',
    messagingSenderId: '907328249742',
    appId: '1:907328249742:web:24fb3bc21433aa0ee90edf',
    measurementId: 'G-YDC1BX79D2',
  },
  firebaseFunctionsUrl:
    'https://europe-west1-monsuividiet-prod-v2.cloudfunctions.net/',
  monthlySubscription: {
    price: 'price_1LFuqkI0uyVAlrPMwKIVzmTA',
    product: 'prod_LxqXGN0pm8iwMc',
  },
  yearlySubscription: {
    price: 'price_1NDogYI0uyVAlrPMax43yFzk',
    product: 'prod_LxqXGN0pm8iwMc',
  },
  monSuiviDietPlus: {
    urlApi: 'https://monsuividietplus.com/api/1.1/wf',
    secret:
      '7c190ca502d8343e19b563bd92b07ae545f69bb2265b5e59b284ed7f78c731b0bbf47f29951894e7ba2983f80694fcf8029acc1b8699ac0dc521162a19c552d7',
  },
  verbosity: LogLevel.warn,
  patient: {
    protocol: 'https',
    domain: 'patient.monsuividiet.com',
    port: undefined,
  },
  dietitian: {
    protocol: 'https',
    domain: 'dashboard.monsuividiet.com',
    port: undefined,
  },
  vapid:
    'BD4INsOx_eT9s6snyyrJsc_QfNO7SKq7jgAtlKYjkCfkuGTicdJsG3CR0O9Ve2d4TU-DSTHieAAVZtf2YyLk5ks',
  superPDP: {
    endpoint: 'https://api.superpdp.tech',
    redirectUri: 'http://localhost:4200/e-invoicing/register',
    clientId: '019e4546-d1a3-75bf-8d9a-85621e977018',
    clientSecret: 'LxkVM5bTolQUl70rehgfwzbL2IfEZtPTzINVnA',
  },
};
